import * as THREE from "three";
import {gsap} from "gsap";
import threeSketch from "../../../libs/three-sketch";
import {FeatureTeamItem} from "./feature-team-item";
import services from "../../../libs/services";
import EmitEvent, {HT_RESIZE, PAGE_ENTER, PAGE_LOADED, SMOOTH_SCROLLING} from "../../../libs/emit-event";
import {MathLerp, MathMap} from "../../../libs/math-utils";
import {Parabola} from "../../../libs/helper";

export class FeatureTeams {
    constructor() {
        this.DOM = {main: document.querySelector('.js-featureTeams')};
        if (!this.DOM.main) return;

        this.DOM.inner = this.DOM.main.querySelector('.js-featureTeams_inner');
        this.DOM.wrap = this.DOM.main.querySelector('.js-featureTeams_wrap');
        this.teams = [];

        this.active = 0;
        this.propWrap = {};
        this.uniforms = {
            u_strength: {
                value: 0.,
            },
            u_res: {value: new THREE.Vector2(services.winSize.width, services.winSize.height)},
        };

        this.styles = {processing: 0};
        this.strength = {
            current: 0,
            currentRun: 0,
            ease: .1
        }

        this.loop = this.loop.bind(this);
        threeSketch.addLoop(this.loop);

        this.handleScrolling = this.handleScrolling.bind(this);
        this.addMesh = this.addMesh.bind(this);
        this.getProp = this.getProp.bind(this);
        this.pageEnter = this.pageEnter.bind(this);
        this.pageResize = this.pageResize.bind(this);

        this.init();
        this.bindEvent();
    }

    init() {
        this.groupList = new THREE.Group();
        threeSketch.addGroup(this.groupList);
        this.DOM.main.querySelectorAll('.js-featureTeamsItem').forEach(item => {
            this.teams.push(new FeatureTeamItem({
                el: item,
                uniforms: this.uniforms,
                addGroup: this.addMesh,
            }));
        });
    }

    addMesh(mesh) {
        this.groupList.add(mesh);
    }

    getProp() {
        const scrollTop = Math.abs(services.smooth_scrolling_instance);
        const reactInner = this.DOM.inner.getBoundingClientRect();
        this.propInner = {
            top: reactInner.top + scrollTop,
            bottom: reactInner.bottom + scrollTop,
            height: reactInner.height,

        }

        this.DOM.main.style.height = `${this.teams.length * .9 * services.winSize.height}px`;
        const rectWrap = this.DOM.main.getBoundingClientRect();
        this.propWrap = {
            bottom: rectWrap.bottom + scrollTop,
            height: rectWrap.height
        };

    }

    handleScrolling({instance}) {
        if (this.teams.length) {

            const maxHeight = (this.propWrap.bottom - this.propInner.bottom);
            const disTop = (this.propInner.top + instance);

            let fixedTop = Math.min(((this.propInner.top - services.winSize.height / 2 + this.propInner.height / 2) + instance), 0);
            fixedTop = Math.max(fixedTop, -maxHeight);

            const disTran = disTop - fixedTop;
            this.DOM.wrap.style.transform = `translate3d(0, ${Math.abs(fixedTop)}px, 0)`;

            for (let i = 0; i < this.teams.length; i++) {
                this.teams[i].handleScrolling(disTran);
            }

            const active = Math.round(MathMap(Math.abs(fixedTop), 0, Math.abs(maxHeight), 0, (this.teams.length - 1)));
            if (this.active > active) {
                this.prevTeam(active);
            } else if (this.active < active) {
                this.nextTeam(active);
            }

            this.active = active;
            threeSketch.render();
        }
    }

    animationRun(active) {

        gsap.to(this.styles, {
            processing: 1, ease: 'power3.inOut', duration: 1., onUpdate: () => {
                this.strength.currentRun = Parabola(this.styles.processing, 1.5) * 150;
            },
            onComplete: () => {
                this.styles.processing = 0;
            }
        });

        this.teams[active].animationIn((this.active < active));
    }

    nextTeam(active) {
        this.animationRun(active);
        this.teams[this.active].animationTop();
    }

    prevTeam(active) {
        this.animationRun(active);
        this.teams[this.active].animationBottom();
    }

    pageEnter() {
        this.teams[0].animationIn();
    }

    loop() {
        // this.strength.current = MathLerp(this.strength.current, Math.abs(services.smooth_scrolling_instance), this.strength.ease)
        // const strengthScroll = MathMap(Math.abs(Math.abs(services.smooth_scrolling_instance) - this.strength.current), 0, 100, 0, 100);
        this.uniforms.u_strength.value = this.strength.currentRun; ///Math.max(this.strength.currentRun, strengthScroll);
    }

    pageResize() {
        this.getProp()
    }

    bindEvent() {
        EmitEvent.on(PAGE_ENTER, this.pageEnter);
        EmitEvent.on(PAGE_LOADED, this.getProp);
        EmitEvent.on(HT_RESIZE, this.pageResize);
        EmitEvent.on(SMOOTH_SCROLLING, this.handleScrolling);
    }

    removeEvent() {
        if (this.teams) {
            this.teams.forEach(item => {
                item.removeEvent();
            });
            threeSketch.removeLoop(this.loop);
            EmitEvent.off(SMOOTH_SCROLLING, this.handleScrolling);
            EmitEvent.off(PAGE_LOADED, this.getProp);
            EmitEvent.off(PAGE_ENTER, this.pageEnter);
            EmitEvent.off(HT_RESIZE, this.pageResize);
            threeSketch.removeGroup(this.groupList);
        }
    }
}